import { Paper, Tab, Tabs } from '@mui/material';
import { throttle } from 'lodash-es';
import React from 'react';

function TabsHeader({
  menu, activeCategoryIndex, onClick, subheaderId,
}) {
  const [topPosition, setTopPosition] = React.useState(84);

  React.useEffect(() => {
    const handleScroll = throttle(() => {
      const headerElement = window.document.getElementById(subheaderId);
      if (headerElement) {
        setTopPosition(headerElement.getBoundingClientRect().bottom);
      }
    }, 150);

    window.addEventListener('scroll', handleScroll);
    return () => {
      handleScroll.cancel();
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <Paper
      sx={{
        borderRadius: 0,
        borderBottom: 1,
        borderColor: 'divider',
        position: 'sticky',
        top: topPosition,
        transform: 'translate3d(0,0,0)',
        transition: 'top 0.2s ease-in-out',
        zIndex: 2,
        px: {
          xs: 0,
          lg: 3,
        },
      }}
      elevation={0}
    >
      <Tabs
        value={activeCategoryIndex}
        variant="scrollable"
        scrollButtons="auto"
      >
        {menu.categories.map((cat, index) => (
          <Tab
            key={index}
            label={cat.name}
            onClick={() => onClick(index)}
            wrapped
          />
        ))}
      </Tabs>
    </Paper>
  );
}

export default TabsHeader;
